var _effectorFileName = "/src/widgets/layouts/main/slider-cards/slider-card/slider-card.tsx";
import { ContactModal } from '@/shared/components/contact-modal';
import CheckMarkIcon from '@/shared/components/icons/checkmark-icon';
import { Badge } from '@/shared/components/ui/badge';
import { Button } from '@/shared/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/shared/components/ui/card';
import { cn } from '@/shared/lib/cn';
import { CardItemProps } from './types';
export const CardItem = (props: CardItemProps) => {
  const {
    item,
    id,
    isActive = false
  } = props;
  return <Card className={cn('flex flex-col transition-all duration-300', isActive && 'border-2 border-brand-accent-normal shadow-md shadow-neutral-500 dark:border-brand-accent-light dark:shadow-neutral-600 sm:shadow-lg')} id={id}>
      <CardHeader className="min-h-[120px] pb-0 md:min-h-[140px]">
        <CardTitle className="mb-1 text-xl font-medium md:text-2xl">{item.title}</CardTitle>
        <CardDescription>{item.description}</CardDescription>
      </CardHeader>

      <CardContent className="leading-6">
        {item.points && <ul className="mt-2 min-h-[120px] space-y-2 text-sm md:min-h-[150px] md:text-base">
            {item.points.map(point => <li className="flex items-start gap-2" key={point.text}>
                <CheckMarkIcon className="mt-1 h-4 w-4 shrink-0 rounded-full bg-brand-accent-light p-[2px] text-white dark:bg-brand-accent-normal" />
                {point.text}
              </li>)}
          </ul>}

        {item.badges && <ul className="mt-6 flex flex-wrap gap-2">
            {item.badges.map(badge => <li key={badge.text}>
                <Badge className="rounded-sm border-brand-accent-normal bg-brand-accent-superLight px-2 py-1 font-mono text-black/80 hover:bg-brand-accent-superLight">
                  {badge.text}
                </Badge>
              </li>)}
          </ul>}
      </CardContent>

      <CardFooter className="h-full items-end">
        <ContactModal entryPoint="GROUP_LESSONS_CARDS">
          <Button variant="cta" className="w-full px-6" aria-label="Записаться на бесплатную консультацию">
            Выбрать
          </Button>
        </ContactModal>
      </CardFooter>
    </Card>;
};